import React, { Component } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Recaptcha from "react-recaptcha";
import { vville, variablesSubstitution, url } from "../components/Variables";
import Spinner from "../components/Spinner";
import { navigate } from "gatsby";

export default class Contact extends Component {
  constructor(props) {
    super();

    this.state = {
      site: vville,
      url: url,
      date: new Date().getTime().toString(),
      verified: false,
      verificationAlert: false,
      email: "",
      SubmitButtonClicked: false,
      call: "",
      canal: "",
      source: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.verificationCallback = this.verificationCallback.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      SubmitButtonClicked: true,
    });

    // Get Select element
    const form = event.target;
    const formData = new FormData(form);
    console.log(new URLSearchParams(formData).toString());
    const formJson = Object.fromEntries(formData.entries());

    if (this.state.verified) {
      fetch(
        "https://us-central1-cci-firebase2022.cloudfunctions.net/sendMessage",
        {
          method: "post",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phone: this.state.phone,
            zipcode: this.state.zipcode,
            description: this.state.description,
            totalSurface: this.state.totalSurface,
            studiedSurface: this.state.studiedSurface,
            call: this.state.call,
            canal: this.state.canal,
            source: formJson.source,
            how: this.state.how,
            site: this.state.site,
            date: this.state.date,
            url: this.state.url,
          }),
        }
      ).then(() => navigate("/message-envoye/"));
    } else {
      this.setState({
        verificationAlert: true,
      });
    }
  }

  verificationCallback() {
    this.setState({
      verified: true,
      verificationAlert: false,
    });
  }

  render() {
    return (
      <Section id="contact-block">
        <FlexWrapper className="flexwrapper">
          <Col1 className="col1">
            <form onSubmit={this.handleSubmit}>
              <BlockTitle className="block-title">
                Une demande de projet&nbsp;?
              </BlockTitle>

              <P>
                Nous vous remercions de nous faire part de votre demande à
                l’aide du formulaire ci-dessous.
                <br />À réception de votre message, nous vous contacterons pour
                discuter de votre projet et vous proposer un rendez-vous sur
                place.
              </P>

              <InputHalf1
                name="firstName"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Prénom *"
                aria-label="Votre prénom"
                required
              />
              <InputHalf2
                name="lastName"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Nom *"
                aria-label="Votre nom"
                required
              />
              <Input
                name="email"
                type="email"
                onChange={this.handleInputChange}
                placeholder="Adresse e-mail *"
                aria-label="Votre adresse e-mail"
                required
              />
              <InputHalf1
                name="phone"
                type="tel"
                onChange={this.handleInputChange}
                placeholder="Numéro de téléphone *"
                aria-label="Votre numéro de téléphone"
                required
              />
              <InputHalf2
                name="zipcode"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Code postal du projet *"
                aria-label="Code postal du projet"
                required
              />
              <Textarea
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="Description de votre projet *"
                aria-label="Description de votre projet"
                required
              />
              <Input
                name="studiedSurface"
                type="text"
                onChange={this.handleInputChange}
                placeholder="Surface à étudier (en m²)"
                aria-label="Surface à étudier (en m²)"
              />

              <label for="canal" id="canal">
                Comment souhaitez-vous être contacté ? *
              </label>
              <Select
                name="canal"
                onChange={this.handleInputChange}
                className={this.state.canal.length > 1 && "active-select"}
                required
              >
                <option value="" disabled selected hidden>
                  Comment souhaitez-vous être contacté ? *
                </option>
                <option value="Par téléphone">Par téléphone</option>
                <option value="Par email">Par email</option>
                <option value="Par SMS / Whatsapp">Par SMS / Whatsapp</option>
              </Select>

              {this.state.canal === "Par téléphone" && (
                <Input
                  name="call"
                  type="text"
                  onChange={this.handleInputChange}
                  placeholder="Quand pouvons-nous vous joindre par téléphone ? "
                  aria-label="Quand pouvons-nous vous joindre par téléphone ? "
                />
              )}

              <label for="source" id="source">
                Comment nous avez-vous connus ?
              </label>
              <Select
                name="source"
                onChange={this.handleInputChange}
                className={this.state.source.length > 1 && "active-select"}
              >
                <option value="" disabled selected hidden>
                  Comment nous avez-vous connus ?
                </option>
                <option value="Recherche sur internet">
                  Recherche sur internet
                </option>
                <option value="Réseaux sociaux">Réseaux sociaux</option>
                <option value="Partenariat BHV">Partenariat BHV</option>
                <option value="Bouche-à-oreille">Bouche-à-oreille</option>
                <option value="Presse">Presse</option>
              </Select>

              <input
                name="site"
                type="text"
                defaultValue={this.state.site}
                css={css`
                  display: none;
                `}
              />

              <input
                name="timestamp"
                type="text"
                defaultValue={this.state.timestamp}
                css={css`
                  display: none;
                `}
              />

              <input
                name="url"
                type="text"
                defaultValue={this.state.url}
                css={css`
                  display: none;
                `}
              />

              {this.state.email.length > 1 && (
                <RecaptchaDiv>
                  <Recaptcha
                    sitekey="6Lct8ooUAAAAAMhjpAWi1U49SMXb84s43FPtMvax"
                    render="explicit"
                    verifyCallback={this.verificationCallback}
                    hl="fr"
                  />
                </RecaptchaDiv>
              )}
              <div
                css={css`
                  clear: both;
                `}
              />

              {this.state.SubmitButtonClicked === false && (
                <InputButton type="submit" value="Envoyer" />
              )}

              <div
                css={css`
                  clear: both;
                `}
              />
              {this.state.SubmitButtonClicked === true &&
                this.state.verified === true && <Spinner />}

              {this.state.verificationAlert && (
                <div
                  css={css`
                    color: red;
                  `}
                >
                  Merci de valider tous les champs requis
                </div>
              )}
            </form>
          </Col1>
          <Col2 className="col2">
            <StaticImage
              src="../images/visuels-home-contact/quimper.jpg"
              alt={variablesSubstitution(
                "Contacter un architecte d'intérieur rville et rdepartement"
              )}
              style={{ borderRadius: "4px", marginTop: "10px" }}
              placeholder="blurred"
              height="635px"
              aspectRatio={423 / 636}
            />
          </Col2>
          <Col3 className="contact-info">
            <p>
              Une <strong>pièce jointe</strong>&nbsp;? Merci d’indiquer un lien
              (Wetransfer, Dropbox, Google Drive, …) vers celle-ci dans le champ
              description de votre projet.
            </p>
            <p>
              Une <strong>pièce jointe par email&nbsp;?</strong> Merci de nous
              l'adresser en renseignant les informations suivantes (téléphone,
              code postal, description du projet et surface concernée) en
              cliquant{" "}
              <a href="mailto:philippe@createursdinterieur.com?subject=Demande%20de%20projet&body=Nom%20+%20Prénom%20:%0A%0ANuméro%20de%20téléphone%20:%0A%0ACode%20postal%20du%20projet%20:%0A%0ADescription%20du%20projet%20:%0A%0ASurface%20à%20étuder%20en%20m2%20:%0A%0A">
                sur ce lien
              </a>
            </p>
          </Col3>
        </FlexWrapper>
      </Section>
    );
  }
}

const Section = styled.div`
  background-image: radial-gradient(#cecdcd 1px, transparent 0);
  background-size: 8px 8px;
`;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 2em 0;
  max-width: 1250px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 2.5em 15px;
  }
`;

const Col1 = styled.div`
  width: 64.5%;
  padding-right: 30px;
  @media (max-width: 800px) {
    width: 100%;
    margin-bottom: 5px;
    padding-right: 0;
    order: 2;
    padding-top: 12px;
  }
`;

const Col2 = styled.div`
  width: 35.5%;
  padding-left: 20px;
  @media (max-width: 800px) {
    width: 100%;
    padding-left: 0;
    order: 1;
  }
`;

const Col3 = styled.div`
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  padding: 0.25em 0.35em 0.1em;
  border-radius: 3px;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    width: 100%;
    order: 3;
  }
`;

const BlockTitle = styled.div`
  font-family: "Raleway", sans-serif;
  color: #333;
  background-color: rgba(255, 255, 255, 1);
  display: block;
  width: fit-content;
  margin-top: 0;
  margin-bottom: 0.5em;
  font-weight: 700;
  font-size: 26px;
  letter-spacing: 0.04em;
  line-height: 28px;
  padding: 0 0.3em;
`;

const P = styled.p`
  display: block;
  padding: 0.3em 0.25em 0.25em 0.55em;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin-bottom: 25px;
`;

const Textarea = styled.textarea`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  letter-spacing: 0.025em;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 45%) !important;
  width: 100%;
  height: 140px;
  min-height: 100px;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
`;

const Input = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 100%;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
`;

const InputHalf1 = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 48%;
  margin-right: 2%;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
  }
`;

const InputHalf2 = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 48%;
  margin-left: 2%;
  margin-bottom: 1.8em;
  font-size: 14px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;

const InputButton = styled.input`
  float: right;
  margin: 0px 0 5px; !important;
  border: 1px solid #7a9282 !important;
  border-radius: 4px;
  font-weight: 700 !important;
  padding: 0.35em 1.5em 0.45em !important;
  font-size: 0.95em !important;
  color: white !important;
  background-color: #7a9282 !important;
  letter-spacing: 0.07em !important;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
  &:hover, &:focus {
    color: white;
    background-color: #202020 !important;
    border: 1px solid #202020 !important;
    transition: all 0.1s ease-in-out !important;
  }
  &:focus {
 
  }
`;

const Select = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  border-radius: 4px;
  border: 1px solid rgb(0 0 0 / 25%);
  color: #757575;
  background-color: white;
  box-shadow: 0px 8px 13px -13px rgb(0 0 0 / 45%) !important;
  width: 100%;
  margin-bottom: 1.8em;
  font-size: 15px;
  padding: 0.5em 0.6em;
  letter-spacing: 0em;
  &:focus {
    box-shadow: 0px 8px 12px -13px rgb(0 0 0 / 75%) !important;
    outline: none;
  }
`;

const RecaptchaDiv = styled.div`
  float: right;
`;
